// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CanaryStatsCountTsx from "./CanaryStatsCount.tsx";

let make = CanaryStatsCountTsx.StatsCount;

export {
  make,
}
/* make Not a pure module */
